
    import * as React from 'react';

    const Clock24 = ({ color = 'currentcolor', height = '24px', width = '24px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 24 24" style={svgStyle}><path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm0-1a9 9 0 110-18 9 9 0 010 18z" /><path d="M12.05 6v5.95H18V13h-7V6h1.05z" /></svg>
        </div>
      );
    };

    Clock24.displayName = 'Clock24';

    export default Clock24;
  